import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import about from '@/components/about'
import login from '@/components/login'
import contact from '@/components/contact'
import personal from '@/components/personal'
import HeadTab from '@/components/HeadTab'
import BomTab from '@/components/BomTab'
import obtain from '@/components/obtain'
import tutorial from '@/components/tutorial'
import conte from '@/components/conte'
import loancard from '@/components/loancard'
import quiz from '@/components/quiz'
import feedback from '@/components/feedback'
import underreview from '@/components/underreview'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },{
      path: '/about',
      name: 'about',
      component: about
    },{
      path: '/login',
      name: 'login',
      component: login
    },{
      path: '/contact',
      name: 'contact',
      component: contact
    },{
      path: '/personal',
      name: 'personal',
      component: personal
    },{
      path: '/HeadTab',
      name: 'HeadTab',
      component: HeadTab
    },{
      path: '/BomTab',
      name: 'BomTab',
      component: BomTab
    },{
      path: '/obtain',
      name: 'obtain',
      component: obtain
    },{
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial
    },{
      path: '/conte',
      name: 'conte',
      component: conte
    },{
      path: '/loancard',
      name: 'loancard',
      component: loancard
    },{
      path: '/quiz',
      name: 'quiz',
      component: quiz
    },{
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },{
      path: '/underreview',
      name: 'underreview',
      component: underreview
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js